import * as angular from 'angular';
import * as moment from 'moment';

import { IDateRangePickerOptions, ComponentDefinition, IDatePickerDates } from '../../models';

class DateRangePickerController implements angular.IComponentController, angular.IOnChanges {
    datePicker: {
        date: IDatePickerDates;
    };

    readonly dates: IDatePickerDates;
    readonly isDisabled: boolean;
    readonly options: IDateRangePickerOptions;
    readonly onRangeChange: (range: { beginDate: moment.Moment; endDate: moment.Moment }) => void;
    
    static $inject = [];

    $onInit() {
        this.datePicker = {
            date: this.dates
        };
        this.options.eventHandlers = {
            'apply.daterangepicker': (_event, _data) => {
                if (this.onRangeChange) {
                    this.onRangeChange({ beginDate: this.datePicker.date.startDate, endDate: this.datePicker.date.endDate });
                }
            },
            'outsideClick.daterangepicker': (_event, _data) => {
                if (this.onRangeChange) {
                    this.onRangeChange({ beginDate: this.datePicker.date.startDate, endDate: this.datePicker.date.endDate });
                }
            }
        };
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (this.datePicker && onChangesObj['dates']?.currentValue) {
            this.datePicker.date = onChangesObj['dates'].currentValue;
        }
    }

    lastHour() {
        if (this.onRangeChange) {
            this.datePicker.date = {
                startDate: moment().add(-1, 'h'),
                endDate: moment()
            };
            this.onRangeChange({ beginDate: moment().add(-1, 'h'), endDate: moment() });
        }
    }

    previous() {
        const startDate = this.datePicker.date.startDate;
        const endDate = this.datePicker.date.endDate;
        const diff = endDate.diff(startDate);
        this.datePicker.date = {
            startDate: startDate.clone().subtract(diff),
            endDate: startDate.clone()
        };
        if (this.onRangeChange) {
            this.onRangeChange({ beginDate: this.datePicker.date.startDate, endDate: this.datePicker.date.endDate });
        }
    }

    next() {
        const startDate = this.datePicker.date.startDate;
        const endDate = this.datePicker.date.endDate;
        const diff = endDate.diff(startDate);
        this.datePicker.date = {
            startDate: endDate.clone(),
            endDate: endDate.clone().add(diff)
        };
        if (this.onRangeChange) {
            this.onRangeChange({ beginDate: this.datePicker.date.startDate, endDate: this.datePicker.date.endDate });
        }
    }
}

export const dateRangePicker: ComponentDefinition = {
    componentId: 'wtDateRangePicker',
    controller: DateRangePickerController,
    controllerAs: 'vm',
    template: require('./dateRangePicker.component.html'),
    bindings: {
        dates: '<',
        isDisabled: '<?',
        options: '<',
        onRangeChange: '&?'
    },
    transclude: true
};